export default __webpack_public_path__ + "static/media/home-interior-design-services.225f0aaf.jpg";